import AsyncStorage from '@react-native-async-storage/async-storage';
import { Dimensions, PixelRatio } from 'react-native';
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from 'react-native-responsive-screen';
import * as WebBrowser from 'expo-web-browser';

export const pixelRatio = PixelRatio.get();
export const ScreenDimensions = () => Dimensions.get('window');
export const ScreenHeight = ScreenDimensions().height;
export const ScreenWidth = ScreenDimensions().width;

export function getOrientarion() {
  return Dimensions.get('window').height > Dimensions.get('window').width ? 'PORTRAIT' : 'LANDSCAPE';
}

export const formalDimensions = (number, scale = 1) => {
  const numberX = number * 1.45;
  if (ScreenWidth < 500) {
    return ScreenWidth * (numberX / 100) * scale;
  }
  return ScreenHeight * (number / 100) * scale;
};

export const pixelDimensions = (number) => (wp(number) > hp(number) ? hp(number)
  : (ScreenWidth / ScreenHeight > 0.7 ? wp(number) * 0.8
    : ScreenWidth / ScreenHeight > 0.6 ? wp(number) * 0.9 : wp(number)
  )
);

export const Logout = (navigation, redirect = true) => {
  AsyncStorage.removeItem('ID');
  AsyncStorage.removeItem('PROFILE');

  if (redirect) { return (navigation.navigate('Base'), window.location.reload()); }
  return null;
};

export const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n) {
    u8arr[n - 1] = bstr.charCodeAt(n - 1);
    n -= 1; // to make eslint happy
  }
  return new File([u8arr], filename, { type: mime });
};

export const handleWebBrowser = async (link) => {
  await WebBrowser.openBrowserAsync(link);
};
